import { GraphSchema } from '@camelot/server';

export interface Activity {
  id: string;
  code: string;
  enabled: boolean;
  descriptionTranslationKey: string;
}

export const activityProps = new GraphSchema<Activity>(['id', 'code', 'enabled', 'descriptionTranslationKey']);
